export enum NoteScope {
    PET_PARENT = 'PET_PARENT',
    PET = 'PET',
    POLICY = 'POLICY',
    CLAIM_REQUEST = 'CLAIM_REQUEST',
}
